import type { FormInstance } from 'antd';
import { InputBaseModel } from '../models';
import { NodeFormValues } from '../types';
import { Utils } from '../../custom_shared/misc';
import { RequiredConditionsValidator } from '.';

export default class FormUtils {
    static applyInputValue(form: FormInstance<NodeFormValues>, input: InputBaseModel) {
        form.setFieldsValue({
            [input.guid]:
                input.dataType === 'DateTime' ? Utils.convertDateValueToPickerValue(input.value) : input.value
        });

        RequiredConditionsValidator.validateRequiredConditions(input);
    }
}
